'use client';

import React, { useEffect, useState } from 'react';

import { useTranslations } from 'next-intl';

import { useDisclosure } from '@mantine/hooks';

import NliAnnouncementModal from '@repo/ui/components/NliAnnouncementModal';

import { useAppDisplayRequestErrors } from '@hooks/useAppDisplayRequestErrors';

import { useAppContext } from '@context/AppContext';

import myFetch from '@utils/myFetch';

const getProxiedImagePath = (imagePath) => {
    const fileName = imagePath?.split(/[\\/]/).pop();

    return fileName ? `announcements/images/${encodeURIComponent(fileName)}` : undefined;
};

export default function Announcement() {
    const t = useTranslations();
    const [announcement, setAnnouncement] = useState({});
    const [openedAnnouncementModal, handlersAnnouncementModal] = useDisclosure(false);
    const [user] = useAppContext('user');
    const displayRequestErrors = useAppDisplayRequestErrors();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const announcementData = await myFetch.get('announcements/check');
                if (!announcementData) {
                    if (window.self !== window.top) {
                        document.getElementById('main').style.minHeight = 'inherit';
                    }
                    return;
                }
                setAnnouncement({
                    ...announcementData,
                    imagePath: getProxiedImagePath(announcementData.imagePath),
                });
                handlersAnnouncementModal.open();
                document.getElementById('main').style.minHeight = '800px';
            } catch (err) {
                displayRequestErrors(err);
            }
        };
        if (user?._id) {
            fetchData();
        }
    }, [user?._id]);

    const onCloseAnnouncementModal = async (seen) => {
        handlersAnnouncementModal.close();
        const body = {
            lastAnnouncement: {
                id: announcement._id,
                seen,
            },
        };
        try {
            await myFetch.patch('users/viewed-announcement', body);
            setAnnouncement({});
            if (window.self !== window.top) {
                document.getElementById('main').style.minHeight = 'inherit';
            }
        } catch (err) {
            displayRequestErrors(err);
        }
    };

    return (
        <NliAnnouncementModal
            announcement={announcement}
            onClose={onCloseAnnouncementModal}
            title={t('announcement')}
            opened={openedAnnouncementModal}
            closeButtonText={t('close')}
            dontShowAgainText={t('do-not-show-again')}
        />
    );
}
